import { render, staticRenderFns } from "./LangSwitch.vue?vue&type=template&id=ecd18c98&scoped=true&"
import script from "./LangSwitch.vue?vue&type=script&lang=ts&"
export * from "./LangSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./LangSwitch.vue?vue&type=style&index=0&id=ecd18c98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd18c98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
